import { IConflictDto } from "@kuika/kuika-cl-model/src/dtos/branch.dto";
import React, { ChangeEvent, useState } from "react";
import { KModal } from "../../ui-kit/k-modal/k-modal";
import { KModalFooter } from "../../ui-kit/k-modal/k-modal-footer";
import KuikaInput from "../../ui-kit/kuika-input/kuika-input";
import KuikaModalIconWrapper from "../../ui-kit/kuika-modal-icon-wrapper/kuika-modal-icon-wrapper";
import KuikaSelectbox from "../../ui-kit/kuika-selectbox/kuika-selectbox";
import KuikaH4 from "../../ui-kit/typography/H4/H4";
import KuikaText from "../../ui-kit/typography/Text/Text";
import "./branching-modal.scss";

export interface IMergeToBranchModalProps {
  showModal: boolean;
  onClose: () => void;
  onStartMerge?: () => void;
  onMerge: (summary: string, description: string, targetBranch: string) => IConflictDto[];
  branches: Array<{ value: string; label: string }>;
  currentBranchId?: string;
}

const MergeToBranchModal: React.FC<IMergeToBranchModalProps> = ({
  showModal,
  onClose,
  onStartMerge,
  onMerge,
  branches,
  currentBranchId
}) => {
  const [summary, setSummary] = useState("");
  const [description, setDescription] = useState("");
  const [targetBranch, setTargetBranch] = useState<string>("");

  const handleSummaryChange = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setSummary(e.target.value);
  };

  const handleDescriptionChange = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setDescription(e.target.value);
  };

  const handleBranchChange = (value: string | number | Array<string | number> | null) => {
    if (typeof value === "string") {
      setTargetBranch(value);
    }
  };

  const handleMerge = () => {
    if (!summary.trim() || !targetBranch) {
      return;
    }
    // Call onStartMerge to just close modal without ending merge flow
    if (onStartMerge) {
      onStartMerge();
    } else {
      onClose();
    }
    onMerge(summary, description, targetBranch);
  };

  const footer = (
    <KModalFooter
      onCancel={onClose}
      submitLabel="Merge"
      onSubmit={handleMerge}
      disabled={!summary.trim() || !targetBranch}
    />
  );

  return (
    <>
      <KModal showModal={showModal} closeModal={onClose} header="Merge to Branch" footer={footer} width={480} centered>
        <div className="kuika-branching-modal">
          <div className="kuika-branching-modal__header">
            <KuikaModalIconWrapper iconName="git-merge" intent="create" />
            <div className="kuika-branching-modal__title">
              <KuikaH4>Merge to Branch</KuikaH4>
            </div>
          </div>
          <div className="kuika-branching-modal__content">
            <div className="kuika-branching-modal__description">
              <KuikaText>Type down the summary and the description before merging the branch</KuikaText>
            </div>
            <div className="kuika-branching-modal__form">
              <div className="kuika-branching-modal__form-item">
                <KuikaInput placeholder="Summary" value={summary} onChange={handleSummaryChange} autoFocus />
              </div>
              <div className="kuika-branching-modal__form-item">
                <KuikaInput
                  type="textarea"
                  placeholder="Description"
                  value={description}
                  onChange={handleDescriptionChange}
                />
              </div>
              <div className="kuika-branching-modal__form-item">
                <KuikaSelectbox
                  placeholder="Merge into"
                  options={branches.filter((branch) => branch.value !== currentBranchId)}
                  value={targetBranch}
                  onChange={handleBranchChange}
                  allowClear
                />
              </div>
            </div>
          </div>
        </div>
      </KModal>
    </>
  );
};

export default MergeToBranchModal;
